























































































































import Vue from 'vue'
import { SnackbarStateEnum } from '@/types/enums'
import { FETCH_EMAIL_TEMPLATE_LIST, FETCH_EMAIL_TEMPLATE_METADATA, SAVE_EMAIL_TEMPLATE } from '@/store/action-types'
import { EmailTemplate } from '@/model/settings/EmailTemplate'
import { DxHtmlEditor, DxItem, DxMediaResizing, DxTableContextMenu, DxToolbar } from 'devextreme-vue/html-editor'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import LanguagesDialog from '@/components/LanguagesDialog.vue'
import ProgressCircular from '@/components/ProgressCircular.vue'

export interface LanguageDataItem {
  languageId: number
  title: string
  text: string
}

interface ComponentData {
  subject: string
  body: string
  selectedTemplate: EmailTemplate | null
  emailGroupList: any[]
  emailTemplateList: EmailTemplate[]
  emailTemplateMetadata: any
  specialWords: Array<string>

  showSnackbar: boolean
  messageSnackbar: string
  snackbarState: number
  loading: boolean
  areaHeight: number

  showLanguagesDialog: boolean
  languagesDialogData: LanguageDataItem[]
  sizeValues: any
  fontValues: any
  headerValues: any
  fontSizeOptions: any
  fontFamilyOptions: any
  headerOptions: any
}

export default Vue.extend({
  name: 'EmailDefaultTextPage',

  components: {
    ProgressCircular,
    LanguagesDialog,
    DxHtmlEditor,
    DxMediaResizing,
    DxToolbar,
    DxTableContextMenu,
    DxItem
  },

  props: {},

  data (): ComponentData {
    return {
      subject: '',
      body: '',
      selectedTemplate: null,
      emailGroupList: [],
      emailTemplateList: [],
      emailTemplateMetadata: null,
      specialWords: [
        ' #Anrede# - Anrede des Empfängers (z.B. Guten Tag #Anrede# ... => Guten Tag Frau ... )',
        ' #Vorname# - Vorname des Empfängers (z.B. Hallo #Vorname# => Hallo Maria)',
        ' #Name# - Name des Empfängers (z.B. Guten Tag #Anrede# #Name# => Guten Tag Frau Müller)',
        ' #Anhang# -  Bezeichnung des Anhangs (z.B. im Betreff: #Anhang# von #Vorname# => Monatsplan von Maria)'
      ],

      showSnackbar: false,
      messageSnackbar: '',
      snackbarState: 0,
      loading: false,
      areaHeight: 200,

      showLanguagesDialog: false,
      languagesDialogData: [],
      sizeValues: ['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt'],
      fontValues: ['Arial', 'Courier New', 'Georgia', 'Impact', 'Lucida Console', 'Tahoma', 'Times New Roman', 'Verdana'],
      headerValues: [false, 1, 2, 3, 4, 5],
      fontSizeOptions: { inputAttr: { 'aria-label': 'Font size' } },
      fontFamilyOptions: { inputAttr: { 'aria-label': 'Font family' } },
      headerOptions: { inputAttr: { 'aria-label': 'Font family' } }
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    selectedLanguageId (): number {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].syzId
    },

    getEmailTypeTitle (): string {
      if(this.selectedTemplate) {
        const foundEmailTemplateType: any | undefined = this.emailTemplateMetadata.SYS_EMTT.find((item: any) => item.Wert === this.selectedTemplate!.eMailTemplateType)
        return foundEmailTemplateType && foundEmailTemplateType.Bezeichnung ? foundEmailTemplateType.Bezeichnung : ''
      } else {
        return ''
      }
    }
  },

  watch: {},

  methods: {
    onResize (): void {
      const minHeight: number = this.$vuetify.breakpoint.lgAndUp ? 300 : 400
      const height: number = window.innerHeight - 420
      this.areaHeight = height > minHeight ? height : minHeight
    },

    isSelectedTemplate (item: EmailTemplate): any {
      if(this.selectedTemplate && this.selectedTemplate.id === item.id) {
        return {border: '1px solid black'}
      } else {
        return {}
      }
    },

    onEmailTemplateClick (item: EmailTemplate): void {
      this.subject = item.subject ? item.subject : ''
      this.body = item.body ? item.body : ''
      this.selectedTemplate = item
      this.languagesDialogData = this.emailTemplateList.filter((i: EmailTemplate) => i.id === item.id && item.sprache !== null).map((i: EmailTemplate) => {
          return {
            languageId: i.sprache!,
            title: i.subject ? i.subject : '',
            text: i.body ? i.body : ''
          }
      })
    },

    onMultiLanguagesDialogOpen (): void {
      if(this.languagesDialogData) {
        let foundTemplateDialogData: LanguageDataItem | undefined = this.languagesDialogData.find((item: LanguageDataItem) => item.languageId === this.selectedLanguageId)
        if (foundTemplateDialogData) {
          foundTemplateDialogData.title = this.subject
          foundTemplateDialogData.text = this.body
        }
      }
      this.showLanguagesDialog = true
    },

    async onSaveLanguagesDialog (data: LanguageDataItem[]): Promise<void> {
      let promisesList: Promise<void>[] = []
      if(this.selectedTemplate) {
        data.forEach((item: LanguageDataItem) => {
          const payload: EmailTemplate = {
            id: this.selectedTemplate!.id,
            eMailTemplateGruppe: this.selectedTemplate!.eMailTemplateGruppe,
            eMailTemplateType: this.selectedTemplate!.eMailTemplateType,
            sprache: item.languageId,
            bezeichnung: this.selectedTemplate!.bezeichnung,
            HTML: this.selectedTemplate!.HTML,
            subject: item.title,
            body: item.text,
          }

          promisesList.push(this.saveEmailTemplate(payload))
        })

        try {
          this.showLanguagesDialog = false
          this.loading = true
          await Promise.all(promisesList)
          this.loading = false
          this.snackbarState = 1
          this.messageSnackbar = this.$t('success.dataHaveBeenSaved').toString()
          this.showSnackbar = true
          this.fetchEmailTemplateList()
        } catch (e) {
          this.loading = false
          this.snackbarState = 0
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved').toString()
          this.showSnackbar = true
        }
      }
    },

    onCloseLanguagesDialog (): void {
      this.showLanguagesDialog = false
    },

    async onSaveButtonClick (): Promise<void> {
      if(this.selectedTemplate) {
        const payload: EmailTemplate = {
          id: this.selectedTemplate!.id,
          eMailTemplateGruppe: this.selectedTemplate!.eMailTemplateGruppe,
          eMailTemplateType: this.selectedTemplate!.eMailTemplateType,
          sprache: this.selectedTemplate!.sprache,
          bezeichnung: this.selectedTemplate!.bezeichnung,
          HTML: this.selectedTemplate!.HTML,
          subject: this.subject,
          body: this.body,
        }

        try {
          this.loading = true
          await this.saveEmailTemplate(payload)
          this.loading = false
          this.snackbarState = 1
          this.messageSnackbar = this.$t('success.dataHaveBeenSaved').toString()
          this.showSnackbar = true
          this.fetchEmailTemplateList()
        } catch (e) {
          this.loading = false
          this.snackbarState = 0
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved').toString()
          this.showSnackbar = true
        }
      }
    },

    async saveEmailTemplate (payload: EmailTemplate): Promise<void> {
      await this.$store.dispatch(SAVE_EMAIL_TEMPLATE, payload)
    },

    async fetchEmailTemplateMetadata (): Promise<void> {
      try {
        this.loading = true
        const response: any = await this.$store.dispatch(FETCH_EMAIL_TEMPLATE_METADATA)
        this.emailTemplateMetadata = response.Data
        this.loading = false
      } catch {
        this.loading = false
        this.snackbarState = 0
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead').toString()
        this.showSnackbar = true
      }
  },

    async fetchEmailTemplateList (): Promise<void> {
      try {
        this.loading = true
        let id: number = 0
        this.emailTemplateList = []
        this.emailGroupList = []
        this.emailTemplateList = await this.$store.dispatch(FETCH_EMAIL_TEMPLATE_LIST)
        this.emailTemplateList.forEach((item: EmailTemplate) => {
          if(item.sprache === this.selectedLanguageId) {
            const foundTemplateGroup: any | undefined = this.emailTemplateMetadata.SYS_EMTG.find((i: any) => i.Wert === item.eMailTemplateGruppe)
            const foundGroup: any | undefined = this.emailGroupList.find((i: any) => i.groupId === item.eMailTemplateGruppe)
            if(foundGroup) {
              foundGroup.template.push(item)
            } else {
              this.emailGroupList.push(
                  {
                    id: id,
                    groupId: item.eMailTemplateGruppe,
                    groupName: foundTemplateGroup && foundTemplateGroup.Bezeichnung ? foundTemplateGroup.Bezeichnung : '',
                    template: [item]
                  }
              )
            }

            id++
          }
        })

        const foundSelectedTemplate: EmailTemplate | undefined = this.emailTemplateList.find((item: EmailTemplate) => this.selectedTemplate !== null && item.id === this.selectedTemplate.id && item.sprache === this.selectedTemplate.sprache)

        if(foundSelectedTemplate) {
          this.onEmailTemplateClick(foundSelectedTemplate)
        }

        this.loading = false
      } catch {
        this.loading = false
        this.snackbarState = 0
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead').toString()
        this.showSnackbar = true
      }
    }

  },

  async mounted () {
    await this.fetchEmailTemplateMetadata()
    await this.fetchEmailTemplateList()

    setTimeout(() => {
      const focusedField: any = this.$refs['focusedField']
      if (focusedField) {
        focusedField.focus()
      }
    }, 0)
  }

})
